export const MONEY_DECIMALS = 3;

export function roundToDecimals(value: number, decimals: number): number {
  if (!Number.isFinite(value)) {
    return 0;
  }

  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

export function addRoundedDecimals(
  values: readonly number[],
  decimals: number
): number {
  const factor = 10 ** decimals;
  const totalUnits = values.reduce((sum, value) => {
    if (!Number.isFinite(value)) {
      return sum;
    }

    return sum + Math.round(value * factor);
  }, 0);

  return totalUnits / factor;
}

export function truncateToDecimals(value: number, decimals: number): number {
  if (!Number.isFinite(value)) {
    return 0;
  }

  const factor = 10 ** decimals;
  const correctedUnits = Math.round(value * factor * 1e6) / 1e6;
  return Math.trunc(correctedUnits) / factor;
}
